module.exports = __webpack_public_path__ + "img/monterey-g-series-rectangle-high-angle.7fde6a59.png";